/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Readiness_TitleInputs */

const en_us2_workout_readiness_title = /** @type {(inputs: Workout_Readiness_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How are you today?`)
};

const pt_br2_workout_readiness_title = /** @type {(inputs: Workout_Readiness_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como você está hoje?`)
};

const es_419_workout_readiness_title = /** @type {(inputs: Workout_Readiness_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo estás hoy?`)
};

const pt_pt2_workout_readiness_title = /** @type {(inputs: Workout_Readiness_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como estás hoje?`)
};

const fr_fr2_workout_readiness_title = /** @type {(inputs: Workout_Readiness_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment tu te sens aujourd'hui ?`)
};

const de_de2_workout_readiness_title = /** @type {(inputs: Workout_Readiness_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie geht's dir heute?`)
};

const it_it2_workout_readiness_title = /** @type {(inputs: Workout_Readiness_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come stai oggi?`)
};

/**
* | output |
* | --- |
* | "How are you today?" |
*
* @param {Workout_Readiness_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_readiness_title = /** @type {((inputs?: Workout_Readiness_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Readiness_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_readiness_title(inputs)
	if (locale === "es-419") return es_419_workout_readiness_title(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_readiness_title(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_readiness_title(inputs)
	if (locale === "de-DE") return de_de2_workout_readiness_title(inputs)
	if (locale === "it-IT") return it_it2_workout_readiness_title(inputs)
	return en_us2_workout_readiness_title(inputs)
});
export { workout_readiness_title as "workout.readiness_title" }